import React, { useCallback, useState } from "react";
import EditorButton from "../components/EditorButton";
import Modal from "../../../Modal";
import FileUploadSingle from "../../../../form/FileUploadSingle";
import Input from "../../../../form/Input";
import Button from "../../../../form/Button";
import UrlInput from "../../../../form/UrlInput";
import { apiRequest } from "../../../../../util/apiUtils";

const ImageAndLink = ({
  editor,
  imageUploadApi = "",
  uploadApiMethod = "post",
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [mode, setMode] = useState(null); // "image" or "link"
  const [inputUrl, setInputUrl] = useState("");

  const openModal = (type) => {
    if (type === "link") {
      const previousUrl = editor.getAttributes("link").href || "";
      setInputUrl(previousUrl);
    } else {
      const previousUrl = editor.getAttributes("image").src || "";
      setInputUrl(previousUrl);
    }
    setMode(type);
    setModalOpen(true);
  };

  const handleInsert = () => {
    if (mode === "image") {
      if (inputUrl) {
        editor.chain().focus().setImage({ src: inputUrl }).run();
      }
    } else if (mode === "link") {
      if (inputUrl === "") {
        editor.chain().focus().unsetLink().run();
      } else {
        editor.chain().focus().setLink({ href: inputUrl }).run();
      }
    }
    setModalOpen(false);
    setInputUrl("");
    setMode(null);
  };

  async function imageUploadHandler(val) {
    if (imageUploadApi) {
      const res = await apiRequest(
        uploadApiMethod,
        imageUploadApi,
        { body: val },
        "multipart/form-data"
      );
      if (res?.status === 200) {
        setInputUrl(res?.data?.url);
      }
    } else {
      setInputUrl(val instanceof File ? URL.createObjectURL(val) : val);
    }
  }

  return (
    <>
      <div className="flex gap-2">
        <EditorButton
          onClick={() => openModal("link")}
          isActive={editor.isActive("link")}
          title="Link"
        >
          <i className="format link"></i>
        </EditorButton>
        {/* <EditorButton onClick={() => openModal("image")} title="Add image">
          <i className="format image"></i>
        </EditorButton> */}
      </div>

      {/* {isModalOpen && (
        <Modal
          isOpen
          onClose={() => setModalOpen(false)}
          header={false}
          size="md"
          bodyClasses="px-4"
          modalDialogueStyle="rounded-lg"
        >
          <button
            className="absolute h-6 w-6 top-3 right-3"
            type="button"
            onClick={() => setModalOpen(false)}
          >
            <i className="fa-fw fa-regular fa-xmark"></i>
          </button>

          <div className="mt-8 space-y-3">
            {mode === "image" && (
              <>
                <FileUploadSingle
                  size="small"
                  onChange={imageUploadHandler}
                  value={inputUrl}
                />
                <div className="flex mx-auto items-center justify-center gap-3 px-10 w-2/3">
                  <div className="bg-gray-300 h-[1px] w-5/12"></div>
                  <span className="text-slate-60 text-secondary uppercase text-sm font-medium">
                    Or
                  </span>
                  <div className="bg-gray-300 h-[1px] w-5/12"></div>
                </div>
              </>
            )}

            <UrlInput value={inputUrl} onChange={setInputUrl} />
          </div>

          <Button
            buttonLabel={"Update"}
            buttonClasses={"w-full mt-5"}
            buttonFunction={handleInsert}
          />
        </Modal>
      )} */}
    </>
  );
};

export default ImageAndLink;
